const Contact = {
    PHONE: '+48783737050',
    EMAIL: 'biuro@sercefinansow.pl',
    FACEBOOK: 'https://www.facebook.com/finansekredytyubezpieczenia',
    INSTAGRAM: 'https://www.instagram.com/sercefinansow/',
  };

  export default Contact;

